<template>
    <div>
        <div class="relative">
            <input
                v-bind="$attrs"
                class="font-artlist"
                :class="['input-field', { value: value, error: error.length > 0 }]"
                v-model="valueModel"
            />
            <label class="font-artlist text-base font-normal floating-label" :class="{'dark': isDarkFloatingLabel}" v-html="label"></label>
            <i v-if="error.length > 0" class="floating-check error-icon fas fa-exclamation-circle"></i>
            <i v-else-if="showValidIcon" class="floating-check fas fa-check-circle"></i>
        </div>
        <div v-show="error.length > 0" class="error-msg text-xs mt-1 ml-3" v-html="error"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        showValidIcon: {
            type: Boolean,
            default: false
        },
        error:  {
            type: String,
            default: ''
        },
        isDarkFloatingLabel: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        valueModel: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style scoped>
.font-artlist {
    font-family: "Artlist Sans";
}
.input-field {
  @apply w-full rounded px-3 pr-8 outline-none bg-transparent float-none shadow-none text-business-dark border border-primary-purple;
  height: 48px;
  font-style: normal;
}
.input-field::-webkit-input-placeholder {
    @apply text-primary-purple;
}
.input-field:-moz-placeholder {
    @apply text-primary-purple;
   opacity:  1;
}
.input-field::-moz-placeholder {
    @apply text-primary-purple;
   opacity:  1;
}
.input-field:-ms-input-placeholder {
    @apply text-primary-purple;
}
.input-field::-ms-input-placeholder {
    @apply text-primary-purple;
}

.input-field::placeholder {
    @apply text-primary-purple;
}

.floating-label {
    @apply absolute pointer-events-none text-primary-purple;
    left: 12px;
    top: calc(50% - 12px);
    transition: all 0.3s;
}

input:focus + .floating-label,
input.value + .floating-label {
    @apply bg-primary-beige;
    left: 0px;
    transform: scale(0.75) translateY(-32px);
    padding-left: 6px;
    padding-right: 6px;
}
input:focus + .floating-label.dark,
input.value + .floating-label.dark {
  @apply bg-primary-purple text-white;
}
input:focus {
  border-color: #333333;
}
.floating-check {
  @apply text-primary-purple absolute;
  top: calc(50% - 8px);
  right: 12px;
}

input.error {
  border-color: #ee5951;
}
input.error + label,
.error-icon,
.error-msg {
  color: #ee5951 !important;
}
</style>
